module.exports = __webpack_public_path__ + "img/Loading_40px.f8eaeff6.svg";